"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _constants = require("../constants"),
    Queue = function Queue() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, Queue), this.onTaskDone = function () {
    _this.runningTasks -= 1, _this.next();
  }, this.runTask = function (task) {
    _this.runningTasks += 1, task(_this.onTaskDone);
  }, this.firstUploadTasks = function () {
    return _this.fileUploads[0];
  }, this.startNextUpload = function () {
    return _this.fileUploads.splice(0, 1), _this.firstUploadTasks() ? _this.next() : null;
  }, this.next = function () {
    return !_this.fileUploads.length || _this.runningTasks >= _constants.MAX_CONCURRENT_PARTS ? null : _this.firstUploadTasks().length ? (_this.runTask(_this.firstUploadTasks().shift()), _this.next()) : _this.runningTasks ? null : _this.startNextUpload();
  }, this.addUploadTasks = function (tasks) {
    _this.fileUploads.push(tasks), _this.next();
  }, this.runningTasks = 0, this.fileUploads = [];
},
    _default = function _default() {
  return new Queue();
};

exports["default"] = _default;